<app-video-help-button *appToolbarExtraButton [videoNumber]="videoNumber" [videoUrl]="videoUrl"></app-video-help-button>
